import { Show as RefineShow, ShowProps } from '@refinedev/mui';
import { IconButton, Typography } from 'ui';
import { ArrowBack } from 'ui/icons';

type Props = Omit<ShowProps, 'goBack' | 'title' | 'breadcrumb'> & {
  onClose: () => void;
  title: string;
};

const Empty = () => null;

export const Show = ({ onClose, title, wrapperProps, headerButtons, ...rest }: Props) => {
  return (
    <RefineShow
      goBack={
        <IconButton onClick={onClose}>
          <ArrowBack />
        </IconButton>
      }
      title={
        <Typography variant="h5" fontWeight="inherit">
          {title}
        </Typography>
      }
      breadcrumb={null}
      headerButtons={headerButtons || <Empty />}
      wrapperProps={{
        ...wrapperProps,
        sx: {
          boxShadow: 'none',
        },
      }}
      {...rest}
    />
  );
};
